import CaretLink from './component.jsx'
export default CaretLink
